module.exports = __webpack_public_path__ + "static/media/image3.5d84e287.png";